<template>
  <modal
    id="modalCriar"
    titulo="Formulário"
    :exibir="exibir"
    :campos="$refs"
    @fechar="fecharModal"
    tamanho="lg"
  >
    <template>
      <form>
        <b-container>
          <!-- INFORMAÇÕES PESSOAIS -->
          <h5>{{ $t('RH.INFORMACOES_PESSOAIS') }}</h5>
          <hr />
          <b-row>
            <b-col cols="12" md="6">
              <input-select-multiple
                v-if="!funcionario.id"
                ref="pessoa"
                v-model="funcionario.pessoaId"
                :placeholder="$t('GERAL.DIGITE_OU_SELECIONE')"
                :label="$t(`ACADEMICO.PESSOA`)"
                :options="opcoes.pessoas"
                @search="buscarPessoas"
                required
              />
              <input-text
                v-else
                ref="pessoa"
                disabled
                v-model="funcionario.nome"
                type="text"
                :label="$t(`ACADEMICO.PESSOA`)"
              />
            </b-col>
            <b-col cols="12" md="6">
              <!-- <input-select-search
                ref="tipoFuncionario"
                v-model="funcionario.tipoFuncionario"
                :label="$t(`RH.TIPO_FUNCIONARIO`)"
                :placeholder="$t('GERAL.DIGITE_OU_SELECIONE')"
                :options="opcoes.tiposFuncionario"
                required
              /> -->
              <input-select-multiple
                ref="tipoFuncionario"
                v-model="funcionario.tipoFuncionario"
                :label="$t(`RH.TIPO_FUNCIONARIO`)"
                :placeholder="$t('GERAL.DIGITE_OU_SELECIONE')"
                :options="opcoes.tiposFuncionario"
                required
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-select-search
                ref="grauInstrucao"
                v-model="funcionario.grauInstrucao"
                :label="$t(`ACADEMICO.GRAU_INSTRUCAO`)"
                :placeholder="$t('GERAL.DIGITE_OU_SELECIONE')"
                :options="opcoes.grauInstrucaoEnums"
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-select-search
                ref="cargos"
                v-model="funcionario.cargo"
                :label="$t(`ACADEMICO.CARGOS`)"
                :placeholder="$t('GERAL.DIGITE_OU_SELECIONE')"
                :options="opcoes.cargosEnum"
                required
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-select-search
                ref="departamento"
                v-model="funcionario.departamento"
                :label="$t(`RH.DEPARTAMENTO`)"
                :placeholder="$t('GERAL.DIGITE_OU_SELECIONE')"
                :options="opcoes.departamentos"
              />
            </b-col>
          </b-row>
          <hr />
          <h5>{{ $t('RH.DOCUMENTOS') }}</h5>
          <b-row>
            <b-col cols="12" md="6">
              <input-mask
                ref="carteiraProfissional"
                v-model="funcionario.carteiraProfissional"
                :label="$t('ACADEMICO.CARTEIRA_PROFISSIONAL')"
                :placeholder="$t('ACADEMICO.CARTEIRA_PROFISSIONAL_PLACE')"
                :mask="['#######/####']"
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-mask
                ref="tituloEleitor"
                v-model="funcionario.tituloEleitor"
                :label="$t('ACADEMICO.TITULO_ELEITOR')"
                :placeholder="$t('ACADEMICO.TITULO_ELEITOR_PLACE')"
                :mask="['############']"
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-mask
                ref="secao"
                v-model="funcionario.secao"
                :label="$t('ACADEMICO.SECAO_ELEITORAL')"
                :placeholder="$t('ACADEMICO.SECAO_ELEITORAL_PLACE')"
                :mask="['####']"
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-text
                ref="pis"
                v-model="funcionario.pis"
                type="text"
                :label="$t('ACADEMICO.PIS_PASEP')"
                :placeholder="$t('ACADEMICO.PIS_PASEP_PLACE')"
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-date-only-btn
                ref="dataAdmissao"
                v-model="funcionario.dataAdmissao"
                :label="$t('RH.DATA_ADMISSAO')"
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-date-only-btn
                ref="dataAdmissao"
                v-model="funcionario.dataDemissao"
                :label="$t('RH.DATA_DEMISSAO')"
              />
            </b-col>
          </b-row>
          <!-- INFORMAÇÕES BANCÁRIAS -->
          <hr />

          <h5>{{ $t('RH.INFORMACOES_BANCARIAS') }}</h5>
          <b-row>
            <b-col cols="12" md="6">
              <input-select-multiple
                ref="bancos"
                v-model="funcionario.banco"
                :label="$t(`ACADEMICO.BANCOS`)"
                :placeholder="$t('GERAL.DIGITE_OU_SELECIONE')"
                :options="opcoes.bancos"
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-mask
                ref="conta"
                v-model="funcionario.conta"
                :label="$t('ACADEMICO.CONTA_BANCARIA')"
                :placeholder="$t('ACADEMICO.CONTA_BANCARIA_PLACE')"
                :mask="['########-#']"
              />
            </b-col>

            <b-col cols="12" md="6">
              <input-mask
                ref="agencia"
                v-model="funcionario.agencia"
                :label="$t('ACADEMICO.AGENCIA_CONTA')"
                :placeholder="$t('ACADEMICO.AGENCIA_CONTA_PLACE')"
                :mask="['####']"
              />
            </b-col>
          </b-row>
          <hr />

          <!-- INFORMAÇÕES TITULAÇÕES -->
          <h5>{{ $t('RH.TITULACOES') }}</h5>
          <b-row>
            <b-col cols="12" md="6">
              <input-mask
                ref="registroProfissional"
                v-model="funcionario.registroProfissional"
                :label="$t('ACADEMICO.REGISTRO_PROFISSIONAL')"
                :placeholder="$t('ACADEMICO.REGISTRO_PROFISSIONAL_PLACE')"
                min="3"
                :mask="['################################################']"
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-text
                ref="titulacoes"
                v-model="funcionario.titulacoes"
                type="text"
                :label="$t('ACADEMICO.TITULACOES')"
                :placeholder="$t('ACADEMICO.TITULACOES_PLACE')"
              />
            </b-col>
            <b-col cols="12" md="6">
              <input-text
                ref="diplomas"
                v-model="funcionario.diplomas"
                type="text"
                :label="$t('ACADEMICO.DIPLOMAS')"
                :placeholder="$t('ACADEMICO.DIPLOMAS_PLACE')"
              />
            </b-col>
          </b-row>
        </b-container>
      </form>
    </template>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvar">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>

<script>
// Utils & Aux:
import VerificacaoPreenchimento from '@/components/mixins/verificacao-preenchimento';
import helpers from '@/common/utils/helpers';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

// Services:
import FuncionarioService from '@/common/services/funcionario/funcionario.service';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service.js';
import BancosService from '@/common/services/bancos/bancos.service.js';
import PessoaService from '@/common/services/pessoa/pessoa.service.js';

// Components:
import Modal from '@/components/modal/Modal.vue';
import {
  InputSelectSearch,
  InputSelectMultipleNovo as InputSelectMultiple,
  InputText,
  InputMask,
  InputDateOnlyBtn,
} from '@/components/inputs';

export default {
  name: 'Formulario',
  mixins: [VerificacaoPreenchimento],
  props: {
    id: { type: String, default: '' },
    dadosPreenchidos: { type: Object, default: Object },
  },
  components: {
    Modal,
    InputSelectSearch,
    InputSelectMultiple,
    InputText,
    InputMask,
    InputDateOnlyBtn,
  },
  data() {
    return {
      refs: [],
      exibir: false,
      funcionario: {
        tipoFuncionario: null,
        grauInstrucao: null,
        cargo: null,
        departamento: null,
        banco: null,
        pessoaId: null,
        carteiraProfissional: null,
        tituloEleitor: null,
        secao: null,
        pis: null,
        dataAdmissao: null,
        registroProfissional: null,
        conta: null,
        agencia: null,
        titulacoes: null,
        diplomas: null,
      },
      opcoes: {
        grauInstrucaoEnums: [],
        cargosEnum: [],
        departamentos: [],
        bancos: [],
        pessoas: [],
      },
      searchTimeout: null,
    };
  },
  watch: {
    dadosPreenchidos: 'preenchimento',
  },
  methods: {
    buscarPessoas(item) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        PessoaService.listarPessoas(
          item,
          { tamanhoDaPagina: 20, numeroDaPagina: 1 },
          'Nome',
          false
        ).then(({ data }) => {
          this.opcoes.pessoas = data.itens.map((i) => ({
            value: i.id,
            text: i.nome,
          }));
        });
      }, 500);
    },
    async abrirModal() {
      // this.getPessoas();
      this.getGrauDeInstrucaoEnum();
      this.getTiposFunctionarioEnum();
      this.getCargosEnum();
      this.getDepartamentos();
      this.getBancos();
      this.exibir = true;
    },
    async carregarDadosFuncionario(id) {
      await Promise.all([
        this.getGrauDeInstrucaoEnum(),
        this.getTiposFunctionarioEnum(),
        this.getCargosEnum(),
        this.getDepartamentos(),
        this.getBancos(),
        FuncionarioService.buscarPorId(id).then((data) => {
          this.funcionario = data;
          this.exibir = true;
        }),
      ]);
    },

    fecharModal() {
      this.limparFormulario();
      this.exibir = false;
    },

    salvar() {
      if (!this.validarFormulario()) return;
      if (this.funcionario.id) {
        this.editar();
      } else {
        this.criar();
      }
    },

    criar() {
      this.$store.dispatch(START_LOADING);
      FuncionarioService.criar(this.funcionario)
        .then((result) => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t(result?.data.mensagem)
          );

          this.fecharModal();
          this.$emit('salvar');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    editar() {
      this.$store.dispatch(START_LOADING);
      FuncionarioService.atualizar(this.funcionario, this.id)
        .then((result) => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t(result?.data.mensagem)
          );
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
          this.$emit('salvar');
        });
    },
    // FUNÇÕES OBTENÇÃO DE DADOS:
    getGrauDeInstrucaoEnum() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('grau-instrucao')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.descricao,
          }));
          this.opcoes.grauInstrucaoEnums = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getCargosEnum() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('cargos')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.descricao,
          }));
          this.opcoes.cargosEnum = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getTiposFunctionarioEnum() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('tipo-funcionarios')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.descricao,
          }));
          this.opcoes.tiposFuncionario = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getBancos() {
      this.$store.dispatch(START_LOADING);
      BancosService.obterTodos()
        .then(({ data }) => {
          data = data.itens.map((row) => ({
            id: row.id,
            codigoBanco: row.codigoBanco,
            descricao: row.descricao,
            value: row.id,
            text: `${row.descricao} - ${row.codigoBanco}`,
          }));
          this.opcoes.bancos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getPessoas() {
      this.$store.dispatch(START_LOADING);
      PessoaService.listarSemPaginacao()
        .then(({ data }) => {
          data = data.map((row) => ({
            value: row.id,
            text: row.nome,
          }));
          this.opcoes.pessoas = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getDepartamentos() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('departamentos')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.descricao,
          }));
          this.opcoes.departamentos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    // FUNÇÕES AUXILIARES:
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },

    limparFormulario() {
      this.funcionario = {
        tipoFuncionario: null,
        grauInstrucao: null,
        cargo: null,
        departamento: null,
        banco: null,
        pessoaId: null,
        carteiraProfissional: null,
        tituloEleitor: null,
        secao: null,
        pis: null,
        dataAdmissao: null,
        registroProfissional: null,
        conta: null,
        agencia: null,
        titulacoes: null,
        diplomas: null,
      };
    },
  },
};
</script>
